export default "__VITE_ASSET__DmOJU19g__"